export default "__VITE_ASSET__9i88I6ND__"